import axios from "./AxiosService";
import { shouldCallCorporateHubEndpoint } from "./../helpers/ShouldCallCorporateHubEndpoint";

const getInboxUrlWithAction = (actionName, serviceParams) => {
  return axios
    .get(`messagecentre/${actionName}`, {
      params: serviceParams
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      throw error && error.response && error.response.data;
    });
};

export function getInboxUrl(membershipNumber, page, messageId) {
  let actionName = shouldCallCorporateHubEndpoint()
    ? "inboxForBristol"
    : "inbox";
  return getInboxUrlWithAction(actionName, {
    membershipNumber,
    page,
    messageId
  });
}

export function getUnreadMessageCount(membershipNumber) {
  return axios
    .get("messagecentre/unreadmessages", {
      avoidLoadingFeature: true,
      params: {
        membershipNumber
      }
    })
    .then(response => {
      return response.data;
    })
    .catch(error => error);
}